// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChargingPageCustom_Orion_chargingMainDiv_Orion__AuQOs .ChargingPageCustom_Orion_btn-primary__NEY1c{
  background-color: #83A4CF !important;
  border-color: #83A4CF !important;
}
.ChargingPageCustom_Orion_chargingMainDiv_Orion__AuQOs .ChargingPageCustom_Orion_btn-outline-primary__Hmecn{
  border-color: #83A4CF !important;
  color: #83A4CF !important;
}
.ChargingPageCustom_Orion_chargingMainDiv_Orion__AuQOs .ChargingPageCustom_Orion_ev_filter_icon__6T\\+oA {
  background: #fff !important;
  color: #83A4CF !important;
}

/* imp code commented */
/* .chargingMainDiv_Bus .btn:focus,
.btn:focus-visible,
.btn:focus-within,
.btn:hover,
.btn:visited,
.btn:active,
.btn:target{
  color: #fff !important;
  background-color: #83A4CF !important;
  border-color: #83A4CF !important;
} */
/* imp code commented */

/*********************** Slow Button *************************/
.ChargingPageCustom_Orion_kpiSlowBTN_Orion__HdIis .ChargingPageCustom_Orion_btn-outline-primary__Hmecn{
  /* color:#83A4CF; */
  border-color:#83A4CF !important;
}
.ChargingPageCustom_Orion_kpiSlowBTN_Orion__HdIis .ChargingPageCustom_Orion_btn-check__QuZYs:checked+.ChargingPageCustom_Orion_btn__h0Tf7:focus-visible, .ChargingPageCustom_Orion_btn__h0Tf7.ChargingPageCustom_Orion_active__ajwDy:focus-visible, .ChargingPageCustom_Orion_btn__h0Tf7.ChargingPageCustom_Orion_show__76TNR:focus-visible, .ChargingPageCustom_Orion_btn__h0Tf7:first-child:active:focus-visible, :not(.ChargingPageCustom_Orion_btn-check__QuZYs)+.ChargingPageCustom_Orion_btn__h0Tf7:active:focus-visible {
  box-shadow: none;
}
.ChargingPageCustom_Orion_kpiSlowBTN_Orion__HdIis .ChargingPageCustom_Orion_btn-outline-primary__Hmecn {
  --bs-btn-color: #83A4CF !important;
  --bs-btn-border-color: #83A4CF !important;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #83A4CF !important;
  --bs-btn-hover-border-color: #83A4CF !important;
  --bs-btn-focus-shadow-rgb: 13,110,253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #83A4CF !important;
  --bs-btn-active-border-color: #83A4CF !important;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #83A4CF !important;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #83A4CF !important;
  --bs-gradient: none;
}

.ChargingPageCustom_Orion_kpiSlowBTN_Orion__HdIis .ChargingPageCustom_Orion_btn-outline-primary__Hmecn:not(:disabled):not(.ChargingPageCustom_Orion_disabled__1nYGt):active, .ChargingPageCustom_Orion_btn-outline-primary__Hmecn:not(:disabled):not(.ChargingPageCustom_Orion_disabled__1nYGt).ChargingPageCustom_Orion_active__ajwDy, .ChargingPageCustom_Orion_show__76TNR>.ChargingPageCustom_Orion_btn-outline-primary__Hmecn.ChargingPageCustom_Orion_dropdown-toggle__\\+Zx8- {
  /* color: #fff; */
  background-color: #83A4CF !important;
  border-color: #83A4CF !important;
  }
  .ChargingPageCustom_Orion_kpiSlowBTN_Orion__HdIis .ChargingPageCustom_Orion_ev_SButton__4MhP6 {
    background: none !important;
    color: #7b7878 !important;
    border-color: #7b7878 !important;
  }

/* imp code commented */
/* .kpiSlowBTN_Bus .btn:focus,
.btn:focus-visible,
.btn:focus-within,
.btn:hover,
.btn:visited,
.btn:active,
.btn:target{
  color: #fff !important;
  background-color: #83A4CF !important;
  border-color: #83A4CF !important;
} */
/* imp code commented */

.ChargingPageCustom_Orion_kpiSlowBTN_Orion__HdIis .ChargingPageCustom_Orion_btn-outline-primary__Hmecn:hover{
  background-color: #83A4CF !important;
  border-color: #83A4CF !important;
}
/*********************** Slow Button Ends *************************/


/*********************** Fast Button *************************/
.ChargingPageCustom_Orion_kpiFastBTN_Orion__rWc3t .ChargingPageCustom_Orion_btn-outline-warning__5h8u3{
  /* color:#3578b0; */
  /* border-color:#3578b0 !important; */
}
.ChargingPageCustom_Orion_kpiFastBTN_Orion__rWc3t .ChargingPageCustom_Orion_btn-check__QuZYs:checked+.ChargingPageCustom_Orion_btn__h0Tf7:focus-visible, .ChargingPageCustom_Orion_btn__h0Tf7.ChargingPageCustom_Orion_active__ajwDy:focus-visible, .ChargingPageCustom_Orion_btn__h0Tf7.ChargingPageCustom_Orion_show__76TNR:focus-visible, .ChargingPageCustom_Orion_btn__h0Tf7:first-child:active:focus-visible, :not(.ChargingPageCustom_Orion_btn-check__QuZYs)+.ChargingPageCustom_Orion_btn__h0Tf7:active:focus-visible {
  box-shadow: none;
}
.ChargingPageCustom_Orion_kpiFastBTN_Orion__rWc3t .ChargingPageCustom_Orion_btn-outline-warning__5h8u3 {
  --bs-btn-color: #3578b0 !important;
  --bs-btn-border-color: #3578b0 !important;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #3578b0 !important;
  --bs-btn-hover-border-color: #3578b0 !important;
  --bs-btn-focus-shadow-rgb: 255,193,7;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #3578b0 !important;
  --bs-btn-active-border-color: #3578b0 !important;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #3578b0 !important;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #3578b0 !important;
  --bs-gradient: none;
}

.ChargingPageCustom_Orion_kpiFastBTN_Orion__rWc3t .ChargingPageCustom_Orion_ev_FButton__REsL3 {
  background: none !important;
  /* color: #3578b0 !important; */
  /* background: #7b7878 !important; */
  /* border: #7b7878; */
  border-color: #7b7878;
}

/* imp code commented */
/* .kpiFastBTN_Bus .btn:focus,
.btn:focus-visible,
.btn:focus-within,
.btn:hover,
.btn:visited,
.btn:active,
.btn:target{
  color: #fff !important;
  background-color: #3578b0;
  border-color: #3578b0;
} */
/* imp code commented */
/*********************** Fast Button Ends *************************/

.ChargingPageCustom_Orion_bg-white__RfA1q{
	background-color:#fff;
}

.ChargingPageCustom_Orion_chargingMainDiv_Orion__AuQOs{
	/* margin-top:80px; */
  margin-top: 15px;
}

.ChargingPageCustom_Orion_chargingWidget_Orion__-0vym{
	/* background: #fff; */
	box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);
	border-radius: 5px;
  background: #CDDAEA;
}
.ChargingPageCustom_Orion_chargingWidgetIcon_Orion__PA9sL img{
	width:50px;
	height:50px;
}
.ChargingPageCustom_Orion_chargingWidgetIcon1_Orion__tN1qo img{
	width:35px;
	height:35px;
}
.ChargingPageCustom_Orion_chargingWidgetIcon_Orion-32_Orion__GUQ7Y img{
	width:32px;height:32px;
}
.ChargingPageCustom_Orion_chargingTitleBg_Orion__OcRV9 {
  /* font-size: 1em;
  color: #0E3157;
  font-weight: 500;
  margin-bottom: 10px;
  text-align: left;
  background: #E0E0E0;
	border-radius: 5px 5px 0 0; */

  font-size: 1em;
  color: #0E3157;
  font-weight: 600;
  margin-bottom: 10px;
  text-align: center;
  background: #E0E0E0;
  border-radius: 5px 5px 0 0;
  /* margin-top: -12px;
  margin-left: -10px;
  margin-right: -10px; */
}
.ChargingPageCustom_Orion_chargingTitleChart_Orion__EAmOB {
    font-size: 0.9em;
    color: #0E3157;
    /* color: #353535; */
    font-weight: 600;
    margin-bottom: 10px;
    text-align: left;
    background: #E0E0E0;
	  border-radius: 5px 5px 0 0;
    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
}

.ChargingPageCustom_Orion_chargingChartbox_Orion__cAp7d{
	/* background: #FFFFFF;
    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
    color: #353535;
	min-height: 280px;
	border-radius: 5px; */
  background: #FFFFFF;
  padding: 0px;
  box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
}

.ChargingPageCustom_Orion_wd_Orion__pGfow{
	min-height: 330px !important;
}
.ChargingPageCustom_Orion_wd_4_charts_Orion__k5NDc{
    min-height: 307px !important;
  }
.ChargingPageCustom_Orion_highlightBoxKpi_Orion__tduGR{
	/* min-height: 310px !important; */
}
.ChargingPageCustom_Orion_highlightTableSec_Orion__zI5Dl{
	min-height: 310px !important;
}
.ChargingPageCustom_Orion_chargingChartHGT_Orion__SjogS{
    padding: 10px;
}

.ChargingPageCustom_Orion_chargingH5_Bus__pABM\\+ .ChargingPageCustom_Orion_h5__0uCjV {
    font-size: 1rem !important;
    /* font-size: 1.1rem !important; */
}
.ChargingPageCustom_Orion_chargingKpiSmallTxt_Orion__\\+UqR4{
	font-size: 77% !important;
    line-height: 1em !important;
}

.ChargingPageCustom_Orion_tableContent_Orion__tadFb table tr td {
	font-size:0.8em;
}

.ChargingPageCustom_Orion_chargingFilterForm_Orion__hKYKN > .ChargingPageCustom_Orion_form-label__oTWVQ{
	font-size:0.825em;
}

.ChargingPageCustom_Orion_chargingHeadfont_Orion__Gfyv4{
	font-size:1.8rem;
}
.ChargingPageCustom_Orion_topRightDropMenu_Orion__w3Hle .ChargingPageCustom_Orion_dropdown-menu__SAfBZ[data-bs-popper] {
    right:0 !important;
	left: auto;
}

/********************  *********************/

.ChargingPageCustom_Orion_contentScroll_Orion__aOfI1{
	/* overflow-y: scroll; */
	/* height:150px; */
}

.ChargingPageCustom_Orion_chargingWidget_Orion__-0vym p {
    line-height: 1rem !important;
}
.ChargingPageCustom_Orion_chargingWidget_Orion__-0vym p small{
	font-size:80% !important;
}

/***************************** Toggle Switch ***************************/
.ChargingPageCustom_Orion_toggleBtn_Orion__NyhuU .ChargingPageCustom_Orion_form-switch__DVjmK .ChargingPageCustom_Orion_form-check-input__IOTj\\+:checked:before {
    content: "C";
    position: absolute;
    width: 20px;
    height: 10px;
    padding-left: 20px;
    margin-top: -1px;
    font-size: 0.7em;
}
.ChargingPageCustom_Orion_toggleBtn_Orion__NyhuU .ChargingPageCustom_Orion_form-switch__DVjmK .ChargingPageCustom_Orion_form-check-input__IOTj\\+:before{
	content: "V";
    position: absolute;
    width: 20px;
    height: 10px;
    padding-left: 5px;
    margin-top: -1px;
    font-size: 0.7em;
}
.ChargingPageCustom_Orion_toggleBtn_Orion__NyhuU .ChargingPageCustom_Orion_form-switch__DVjmK .ChargingPageCustom_Orion_form-check-input__IOTj\\+{
	color:#83A4CF !important;
}

/* k */
.ChargingPageCustom_Orion_toggleBtn_Orion__NyhuU .ChargingPageCustom_Orion_toggle-button-cover__fjYKl {
  position: relative;
  top: 8px;
}
.ChargingPageCustom_Orion_dropdownSelectBtnCharging_Orion__q1B-u{
	width: fit-content;
}
.ChargingPageCustom_Orion_toggleBtn_Orion__NyhuU .ChargingPageCustom_Orion_button-cover__tM2eX {
  background-color: #fff;
  box-shadow: 0 10px 20px -8px #c5d6d6;
  border-radius: 4px;
}

.ChargingPageCustom_Orion_toggleBtn_Orion__NyhuU .ChargingPageCustom_Orion_button-cover__tM2eX:before {
  color: #d7e3e3;
  font-size: 12px;
  line-height: 1;
  padding: 5px;
}

.ChargingPageCustom_Orion_toggleBtn_Orion__NyhuU .ChargingPageCustom_Orion_button-cover__tM2eX,
.ChargingPageCustom_Orion_knobs__KpbVZ,
.ChargingPageCustom_Orion_layer__VBu\\+e {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.ChargingPageCustom_Orion_toggleBtn_Orion__NyhuU .ChargingPageCustom_Orion_buttonbtn__7PVto {
  position: relative;
  top: 50%;
  width: 50px;
}

.ChargingPageCustom_Orion_toggleBtn_Orion__NyhuU .ChargingPageCustom_Orion_buttonbtn__7PVto.ChargingPageCustom_Orion_r__WzkzU,
.ChargingPageCustom_Orion_buttonbtn__7PVto.ChargingPageCustom_Orion_r__WzkzU .ChargingPageCustom_Orion_layer__VBu\\+e {
  border-radius: 100px;
}

.ChargingPageCustom_Orion_toggleBtn_Orion__NyhuU .ChargingPageCustom_Orion_button__YeNzs.ChargingPageCustom_Orion_b2__iU8i- {
  border-radius: 2px;
}

.ChargingPageCustom_Orion_toggleBtn_Orion__NyhuU .ChargingPageCustom_Orion_checkbox__tbLv7 {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 3;
}

.ChargingPageCustom_Orion_toggleBtn_Orion__NyhuU .ChargingPageCustom_Orion_knobs__KpbVZ {
  z-index: 2;
}

.ChargingPageCustom_Orion_toggleBtn_Orion__NyhuU .ChargingPageCustom_Orion_layer__VBu\\+e {
  width: 100%;
  background-color: #ebf7fc;
  transition: 0.3s ease all;
  z-index: 1;
}
/* Button 1 */
#ChargingPageCustom_Orion_button-1_Orion__fj84X .ChargingPageCustom_Orion_knobs__KpbVZ:before {
  content: "V";
  position: absolute;
  top: 0px;
  left: 0px;
  width: 20px;
  height: 20px;
  color: #fff;
  font-size: 10px;
  font-weight: bold;
  text-align: center;
  line-height: 1;
  padding: 6px 4px;
  background-color: #83A4CF;
  border-radius: 50%;
  transition: 0.3s cubic-bezier(0.18, 0.89, 0.35, 1.15) all;
}

#ChargingPageCustom_Orion_button-1_Orion__fj84X .ChargingPageCustom_Orion_checkbox__tbLv7:checked + .ChargingPageCustom_Orion_knobs__KpbVZ:before {
  content: "C";
  left: 30px;
  background-color: #3578b0;
}

#ChargingPageCustom_Orion_button-1_Orion__fj84X .ChargingPageCustom_Orion_checkbox__tbLv7:checked ~ .ChargingPageCustom_Orion_layer__VBu\\+e {
  /* fent orange change */
  /* background-color: #fcebeb; */
  background-color: #94c1e6;
}

#ChargingPageCustom_Orion_button-1_Orion__fj84X .ChargingPageCustom_Orion_knobs__KpbVZ,
#ChargingPageCustom_Orion_button-1_Orion__fj84X .ChargingPageCustom_Orion_knobs__KpbVZ:before,
#ChargingPageCustom_Orion_button-1_Orion__fj84X .ChargingPageCustom_Orion_layer__VBu\\+e {
  transition: 0.3s ease all;
}

/***************************** PageTwo *******************************/

/*************************  *****************************/
.ChargingPageCustom_Orion_kpiNotificationSlow_Orion__VIBOR{
	color: #83A4CF;
    font-size: 0.7em;
    font-weight: 500;
}
.ChargingPageCustom_Orion_kpiNotificationFast_Orion__JCSF5{
	color:#3578b0;
	font-size:0.7em;
	font-weight:500;
}

.ChargingPageCustom_Orion_kpiNotificationBoth_Orion__PaF6n{
	color:#72D817;
	font-size:0.7em;
	font-weight:500;
}
/* media queries start here */

@media (min-width: 1440px) {
.ChargingPageCustom_Orion_col205__M79z8{
	flex: 0 0 auto;
    width: 20% !important;
}
}

@media (max-width: 1440px) {
.ChargingPageCustom_Orion_highlightTableSec_Orion__zI5Dl{
	min-height: 310px !important;
}
}

@media (min-width: 1336px) {
.ChargingPageCustom_Orion_col205__M79z8{
	flex: 0 0 auto;
    width: 20% !important;
}
}


@media (max-width: 1024px) {
.ChargingPageCustom_Orion_highlightTableSec_Orion__zI5Dl{
	min-height: 330px !important;
}
}


@media (min-width: 992px) {
.ChargingPageCustom_Orion_col205__M79z8{
	flex: 0 0 auto;
    width: 20% !important;
}
}


@media (min-width: 836px) {
/* .navbar-expand-sm { */
    /* flex-wrap: nowrap !important; */
    /* justify-content: flex-start !important; */
/* } */
}

@media screen and (max-width: 740px) {
.ChargingPageCustom_Orion_chargingTitleBg_Orion__OcRV9 {
	font-size: 0.9em;
}
}


@media screen and (max-width: 720px) {
/* .chargingMainDiv_Bus{ */
	/* margin-top:124px; */
/* } */
}

@media screen and (max-width: 480px) {
/* .chargingMainDiv_Bus{ */
	/* margin-top:155px; */
/* } */
}
	
@media screen and (max-width: 480px) {

.ChargingPageCustom_Orion_chargingHeadfont_Orion__Gfyv4 {
    font-size: 1rem;
}
.ChargingPageCustom_Orion_chargingTitleBg_Orion__OcRV9 {
	font-size: 0.9em;
}
}

@media screen and (max-width: 320px) {

}

.ChargingPageCustom_Orion_highlight_five_Orion__HM9ss{
  margin: auto;
}

.ChargingPageCustom_Orion_text_bottom_Orion__-LR1Z{
  margin-bottom: '-16px !important';
  display: none;
  z-index: 1;
}
.ChargingPageCustom_Orion_btn-infotable_Orion__IC3NF:active {
  color: black;
  background-color: #fff;
  border-color: #32879c; 
}

/* .col-19 {
  flex: 0 0 calc(100% / 19);
  max-width: calc(100% / 19);
} */

@media (min-width: 1440px) {
  .ChargingPageCustom_Orion_col-19__TJ3yP {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(100% / 19);
  max-width: calc(100% / 19);
  }
}

@media (min-width: 1336px) {
  .ChargingPageCustom_Orion_col-19__TJ3yP {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(100% / 19);
  max-width: calc(100% / 19);
  }
}

@media (min-width: 992px) {
  .ChargingPageCustom_Orion_col-19__TJ3yP {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(100% / 19);
  max-width: calc(100% / 19);
  }
}


/* @media (max-width: 576px) {
  .col-19 {
      flex: 0 0 calc(100% / 19);
      max-width: calc(100% / 19);
    }
}

@media (min-width: 576px) and (max-width: 768px) {
  .col-19 {
      flex: 0 0 calc(100% / 19);
      max-width: calc(100% / 19);
    }
}

@media (min-width: 768px) and (max-width: 992px) {
  .col-19 {
      flex: 0 0 calc(100% / 19);
      max-width: calc(100% / 19);
    }
}

@media (min-width: 992px) {
  .col-19 {
      flex: 0 0 calc(100% / 19);
      max-width: calc(100% / 19);
    }
} */

.ChargingPageCustom_Orion_chargingChartboxNew_Orion__wo0aq {
  background: #FFFFFF;
  padding: 0px;
  box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
  height: 293px;
}

.ChargingPageCustom_Orion_highBold__Z-WGN {
  font-weight: bold;
  color: black;
  font-size:16px !important
}

.ChargingPageCustom_Orion_filter_Orion_icon_f__zBCh0 .ChargingPageCustom_Orion_rca_btn__3sgvG .ChargingPageCustom_Orion_rca_btn_Orion__Btw4S  {
  background-color: #ffa650;
}
.ChargingPageCustom_Orion_filter_Orion_icon_f__zBCh0 .ChargingPageCustom_Orion_rca_btn__3sgvG .ChargingPageCustom_Orion_rca_btn_Orion__Btw4S:hover{
  background-color: #fcb877 !important; 
  border-color: #fcb877 !important;
}

.ChargingPageCustom_Orion_popUpTable__zG9t8{
  background-color: rgb(131, 164, 207);
  color: rgb(255, 255, 255);
  position: sticky;
  top: 0;
  z-index: 0;
}

.ChargingPageCustom_Orion_custom-table__JiZGa .ChargingPageCustom_Orion_p-datatable-thead__eQNsf th {
  background-color: #83A4CF;
  /* Set your desired background color */
  color: white;
  /* Set your desired text color */
}

/* .custom-table .p-sortable-column .p-column-title .p-sortable-column-icon.pi-sort { */
.ChargingPageCustom_Orion_custom-table__JiZGa .ChargingPageCustom_Orion_p-sortable-column__3Y6QK .ChargingPageCustom_Orion_p-column-header-content__sm5G3 .ChargingPageCustom_Orion_p-sortable-column-icon__z5dMX {
  color: white;
  height: 20px!important;
  width: 12px!important;
  /* Set your desired arrow color */
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Orion/Charginganalysis_Orion/ChargingPageCustom_Orion.module.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;;;;;;;;;;GAUG;AACH,uBAAuB;;AAEvB,8DAA8D;AAC9D;EACE,mBAAmB;EACnB,+BAA+B;AACjC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,yCAAyC;EACzC,0BAA0B;EAC1B,qCAAqC;EACrC,+CAA+C;EAC/C,qCAAqC;EACrC,2BAA2B;EAC3B,sCAAsC;EACtC,gDAAgD;EAChD,4DAA4D;EAC5D,2CAA2C;EAC3C,iCAAiC;EACjC,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,gCAAgC;EAChC;EACA;IACE,2BAA2B;IAC3B,yBAAyB;IACzB,gCAAgC;EAClC;;AAEF,uBAAuB;AACvB;;;;;;;;;;GAUG;AACH,uBAAuB;;AAEvB;EACE,oCAAoC;EACpC,gCAAgC;AAClC;AACA,mEAAmE;;;AAGnE,8DAA8D;AAC9D;EACE,mBAAmB;EACnB,qCAAqC;AACvC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,yCAAyC;EACzC,0BAA0B;EAC1B,qCAAqC;EACrC,+CAA+C;EAC/C,oCAAoC;EACpC,2BAA2B;EAC3B,sCAAsC;EACtC,gDAAgD;EAChD,4DAA4D;EAC5D,2CAA2C;EAC3C,iCAAiC;EACjC,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,oCAAoC;EACpC,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;;;;;;;;;;GAUG;AACH,uBAAuB;AACvB,mEAAmE;;AAEnE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;EACpB,gBAAgB;AAClB;;AAEA;CACC,sBAAsB;CACtB,4CAA4C;CAC5C,kBAAkB;EACjB,mBAAmB;AACrB;AACA;CACC,UAAU;CACV,WAAW;AACZ;AACA;CACC,UAAU;CACV,WAAW;AACZ;AACA;CACC,UAAU,CAAC,WAAW;AACvB;AACA;EACE;;;;;;8BAM4B;;EAE5B,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B;;wBAEsB;AACxB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;GACpB,0BAA0B;IACzB,wCAAwC;AAC5C;;AAEA;CACC;;;;sBAIqB;EACpB,mBAAmB;EACnB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;CACC,4BAA4B;AAC7B;AACA;IACI,4BAA4B;EAC9B;AACF;CACC,kCAAkC;AACnC;AACA;CACC,4BAA4B;AAC7B;AACA;IACI,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,kCAAkC;AACtC;AACA;CACC,yBAAyB;IACtB,2BAA2B;AAC/B;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;AACA;IACI,kBAAkB;CACrB,UAAU;AACX;;AAEA,4CAA4C;;AAE5C;CACC,wBAAwB;CACxB,kBAAkB;AACnB;;AAEA;IACI,4BAA4B;AAChC;AACA;CACC,wBAAwB;AACzB;;AAEA,wEAAwE;AACxE;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;CACC,YAAY;IACT,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;CACC,wBAAwB;AACzB;;AAEA,MAAM;AACN;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;CACC,kBAAkB;AACnB;AACA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;;;EAGE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,UAAU;EACV,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,UAAU;AACZ;AACA,aAAa;AACb;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA,sEAAsE;;AAEtE,yDAAyD;AACzD;CACC,cAAc;IACX,gBAAgB;IAChB,gBAAgB;AACpB;AACA;CACC,aAAa;CACb,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,eAAe;CACf,eAAe;AAChB;AACA,6BAA6B;;AAE7B;AACA;CACC,cAAc;IACX,qBAAqB;AACzB;AACA;;AAEA;AACA;CACC,4BAA4B;AAC7B;AACA;;AAEA;AACA;CACC,cAAc;IACX,qBAAqB;AACzB;AACA;;;AAGA;AACA;CACC,4BAA4B;AAC7B;AACA;;;AAGA;AACA;CACC,cAAc;IACX,qBAAqB;AACzB;AACA;;;AAGA;AACA,wBAAwB;IACpB,kCAAkC;IAClC,4CAA4C;AAChD,MAAM;AACN;;AAEA;AACA;CACC,gBAAgB;AACjB;AACA;;;AAGA;AACA,0BAA0B;CACzB,sBAAsB;AACvB,MAAM;AACN;;AAEA;AACA,0BAA0B;CACzB,sBAAsB;AACvB,MAAM;AACN;;AAEA;;AAEA;IACI,eAAe;AACnB;AACA;CACC,gBAAgB;AACjB;AACA;;AAEA;;AAEA;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,aAAa;EACb,UAAU;AACZ;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;;GAGG;;AAEH;EACE;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;EAC3B,0BAA0B;EAC1B;AACF;;AAEA;EACE;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;EAC3B,0BAA0B;EAC1B;AACF;;AAEA;EACE;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;EAC3B,0BAA0B;EAC1B;AACF;;;AAGA;;;;;;;;;;;;;;;;;;;;;;;;;;GA0BG;;AAEH;EACE,mBAAmB;EACnB,YAAY;EACZ,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ;AACF;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,YAAY;EACZ,gCAAgC;AAClC;;AAEA,uFAAuF;AACvF;EACE,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;EACrB,iCAAiC;AACnC","sourcesContent":[".chargingMainDiv_Orion .btn-primary{\n  background-color: #83A4CF !important;\n  border-color: #83A4CF !important;\n}\n.chargingMainDiv_Orion .btn-outline-primary{\n  border-color: #83A4CF !important;\n  color: #83A4CF !important;\n}\n.chargingMainDiv_Orion .ev_filter_icon {\n  background: #fff !important;\n  color: #83A4CF !important;\n}\n\n/* imp code commented */\n/* .chargingMainDiv_Bus .btn:focus,\n.btn:focus-visible,\n.btn:focus-within,\n.btn:hover,\n.btn:visited,\n.btn:active,\n.btn:target{\n  color: #fff !important;\n  background-color: #83A4CF !important;\n  border-color: #83A4CF !important;\n} */\n/* imp code commented */\n\n/*********************** Slow Button *************************/\n.kpiSlowBTN_Orion .btn-outline-primary{\n  /* color:#83A4CF; */\n  border-color:#83A4CF !important;\n}\n.kpiSlowBTN_Orion .btn-check:checked+.btn:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible, .btn:first-child:active:focus-visible, :not(.btn-check)+.btn:active:focus-visible {\n  box-shadow: none;\n}\n.kpiSlowBTN_Orion .btn-outline-primary {\n  --bs-btn-color: #83A4CF !important;\n  --bs-btn-border-color: #83A4CF !important;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #83A4CF !important;\n  --bs-btn-hover-border-color: #83A4CF !important;\n  --bs-btn-focus-shadow-rgb: 13,110,253;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #83A4CF !important;\n  --bs-btn-active-border-color: #83A4CF !important;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #83A4CF !important;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #83A4CF !important;\n  --bs-gradient: none;\n}\n\n.kpiSlowBTN_Orion .btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show>.btn-outline-primary.dropdown-toggle {\n  /* color: #fff; */\n  background-color: #83A4CF !important;\n  border-color: #83A4CF !important;\n  }\n  .kpiSlowBTN_Orion .ev_SButton {\n    background: none !important;\n    color: #7b7878 !important;\n    border-color: #7b7878 !important;\n  }\n\n/* imp code commented */\n/* .kpiSlowBTN_Bus .btn:focus,\n.btn:focus-visible,\n.btn:focus-within,\n.btn:hover,\n.btn:visited,\n.btn:active,\n.btn:target{\n  color: #fff !important;\n  background-color: #83A4CF !important;\n  border-color: #83A4CF !important;\n} */\n/* imp code commented */\n\n.kpiSlowBTN_Orion .btn-outline-primary:hover{\n  background-color: #83A4CF !important;\n  border-color: #83A4CF !important;\n}\n/*********************** Slow Button Ends *************************/\n\n\n/*********************** Fast Button *************************/\n.kpiFastBTN_Orion .btn-outline-warning{\n  /* color:#3578b0; */\n  /* border-color:#3578b0 !important; */\n}\n.kpiFastBTN_Orion .btn-check:checked+.btn:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible, .btn:first-child:active:focus-visible, :not(.btn-check)+.btn:active:focus-visible {\n  box-shadow: none;\n}\n.kpiFastBTN_Orion .btn-outline-warning {\n  --bs-btn-color: #3578b0 !important;\n  --bs-btn-border-color: #3578b0 !important;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #3578b0 !important;\n  --bs-btn-hover-border-color: #3578b0 !important;\n  --bs-btn-focus-shadow-rgb: 255,193,7;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #3578b0 !important;\n  --bs-btn-active-border-color: #3578b0 !important;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #3578b0 !important;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #3578b0 !important;\n  --bs-gradient: none;\n}\n\n.kpiFastBTN_Orion .ev_FButton {\n  background: none !important;\n  /* color: #3578b0 !important; */\n  /* background: #7b7878 !important; */\n  /* border: #7b7878; */\n  border-color: #7b7878;\n}\n\n/* imp code commented */\n/* .kpiFastBTN_Bus .btn:focus,\n.btn:focus-visible,\n.btn:focus-within,\n.btn:hover,\n.btn:visited,\n.btn:active,\n.btn:target{\n  color: #fff !important;\n  background-color: #3578b0;\n  border-color: #3578b0;\n} */\n/* imp code commented */\n/*********************** Fast Button Ends *************************/\n\n.bg-white{\n\tbackground-color:#fff;\n}\n\n.chargingMainDiv_Orion{\n\t/* margin-top:80px; */\n  margin-top: 15px;\n}\n\n.chargingWidget_Orion{\n\t/* background: #fff; */\n\tbox-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);\n\tborder-radius: 5px;\n  background: #CDDAEA;\n}\n.chargingWidgetIcon_Orion img{\n\twidth:50px;\n\theight:50px;\n}\n.chargingWidgetIcon1_Orion img{\n\twidth:35px;\n\theight:35px;\n}\n.chargingWidgetIcon_Orion-32_Orion img{\n\twidth:32px;height:32px;\n}\n.chargingTitleBg_Orion {\n  /* font-size: 1em;\n  color: #0E3157;\n  font-weight: 500;\n  margin-bottom: 10px;\n  text-align: left;\n  background: #E0E0E0;\n\tborder-radius: 5px 5px 0 0; */\n\n  font-size: 1em;\n  color: #0E3157;\n  font-weight: 600;\n  margin-bottom: 10px;\n  text-align: center;\n  background: #E0E0E0;\n  border-radius: 5px 5px 0 0;\n  /* margin-top: -12px;\n  margin-left: -10px;\n  margin-right: -10px; */\n}\n.chargingTitleChart_Orion {\n    font-size: 0.9em;\n    color: #0E3157;\n    /* color: #353535; */\n    font-weight: 600;\n    margin-bottom: 10px;\n    text-align: left;\n    background: #E0E0E0;\n\t  border-radius: 5px 5px 0 0;\n    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n}\n\n.chargingChartbox_Orion{\n\t/* background: #FFFFFF;\n    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n    color: #353535;\n\tmin-height: 280px;\n\tborder-radius: 5px; */\n  background: #FFFFFF;\n  padding: 0px;\n  box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n}\n\n.wd_Orion{\n\tmin-height: 330px !important;\n}\n.wd_4_charts_Orion{\n    min-height: 307px !important;\n  }\n.highlightBoxKpi_Orion{\n\t/* min-height: 310px !important; */\n}\n.highlightTableSec_Orion{\n\tmin-height: 310px !important;\n}\n.chargingChartHGT_Orion{\n    padding: 10px;\n}\n\n.chargingH5_Bus .h5 {\n    font-size: 1rem !important;\n    /* font-size: 1.1rem !important; */\n}\n.chargingKpiSmallTxt_Orion{\n\tfont-size: 77% !important;\n    line-height: 1em !important;\n}\n\n.tableContent_Orion table tr td {\n\tfont-size:0.8em;\n}\n\n.chargingFilterForm_Orion > .form-label{\n\tfont-size:0.825em;\n}\n\n.chargingHeadfont_Orion{\n\tfont-size:1.8rem;\n}\n.topRightDropMenu_Orion .dropdown-menu[data-bs-popper] {\n    right:0 !important;\n\tleft: auto;\n}\n\n/********************  *********************/\n\n.contentScroll_Orion{\n\t/* overflow-y: scroll; */\n\t/* height:150px; */\n}\n\n.chargingWidget_Orion p {\n    line-height: 1rem !important;\n}\n.chargingWidget_Orion p small{\n\tfont-size:80% !important;\n}\n\n/***************************** Toggle Switch ***************************/\n.toggleBtn_Orion .form-switch .form-check-input:checked:before {\n    content: \"C\";\n    position: absolute;\n    width: 20px;\n    height: 10px;\n    padding-left: 20px;\n    margin-top: -1px;\n    font-size: 0.7em;\n}\n.toggleBtn_Orion .form-switch .form-check-input:before{\n\tcontent: \"V\";\n    position: absolute;\n    width: 20px;\n    height: 10px;\n    padding-left: 5px;\n    margin-top: -1px;\n    font-size: 0.7em;\n}\n.toggleBtn_Orion .form-switch .form-check-input{\n\tcolor:#83A4CF !important;\n}\n\n/* k */\n.toggleBtn_Orion .toggle-button-cover {\n  position: relative;\n  top: 8px;\n}\n.dropdownSelectBtnCharging_Orion{\n\twidth: fit-content;\n}\n.toggleBtn_Orion .button-cover {\n  background-color: #fff;\n  box-shadow: 0 10px 20px -8px #c5d6d6;\n  border-radius: 4px;\n}\n\n.toggleBtn_Orion .button-cover:before {\n  color: #d7e3e3;\n  font-size: 12px;\n  line-height: 1;\n  padding: 5px;\n}\n\n.toggleBtn_Orion .button-cover,\n.knobs,\n.layer {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.toggleBtn_Orion .buttonbtn {\n  position: relative;\n  top: 50%;\n  width: 50px;\n}\n\n.toggleBtn_Orion .buttonbtn.r,\n.buttonbtn.r .layer {\n  border-radius: 100px;\n}\n\n.toggleBtn_Orion .button.b2 {\n  border-radius: 2px;\n}\n\n.toggleBtn_Orion .checkbox {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  margin: 0;\n  opacity: 0;\n  cursor: pointer;\n  z-index: 3;\n}\n\n.toggleBtn_Orion .knobs {\n  z-index: 2;\n}\n\n.toggleBtn_Orion .layer {\n  width: 100%;\n  background-color: #ebf7fc;\n  transition: 0.3s ease all;\n  z-index: 1;\n}\n/* Button 1 */\n#button-1_Orion .knobs:before {\n  content: \"V\";\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 20px;\n  height: 20px;\n  color: #fff;\n  font-size: 10px;\n  font-weight: bold;\n  text-align: center;\n  line-height: 1;\n  padding: 6px 4px;\n  background-color: #83A4CF;\n  border-radius: 50%;\n  transition: 0.3s cubic-bezier(0.18, 0.89, 0.35, 1.15) all;\n}\n\n#button-1_Orion .checkbox:checked + .knobs:before {\n  content: \"C\";\n  left: 30px;\n  background-color: #3578b0;\n}\n\n#button-1_Orion .checkbox:checked ~ .layer {\n  /* fent orange change */\n  /* background-color: #fcebeb; */\n  background-color: #94c1e6;\n}\n\n#button-1_Orion .knobs,\n#button-1_Orion .knobs:before,\n#button-1_Orion .layer {\n  transition: 0.3s ease all;\n}\n\n/***************************** PageTwo *******************************/\n\n/*************************  *****************************/\n.kpiNotificationSlow_Orion{\n\tcolor: #83A4CF;\n    font-size: 0.7em;\n    font-weight: 500;\n}\n.kpiNotificationFast_Orion{\n\tcolor:#3578b0;\n\tfont-size:0.7em;\n\tfont-weight:500;\n}\n\n.kpiNotificationBoth_Orion{\n\tcolor:#72D817;\n\tfont-size:0.7em;\n\tfont-weight:500;\n}\n/* media queries start here */\n\n@media (min-width: 1440px) {\n.col205{\n\tflex: 0 0 auto;\n    width: 20% !important;\n}\n}\n\n@media (max-width: 1440px) {\n.highlightTableSec_Orion{\n\tmin-height: 310px !important;\n}\n}\n\n@media (min-width: 1336px) {\n.col205{\n\tflex: 0 0 auto;\n    width: 20% !important;\n}\n}\n\n\n@media (max-width: 1024px) {\n.highlightTableSec_Orion{\n\tmin-height: 330px !important;\n}\n}\n\n\n@media (min-width: 992px) {\n.col205{\n\tflex: 0 0 auto;\n    width: 20% !important;\n}\n}\n\n\n@media (min-width: 836px) {\n/* .navbar-expand-sm { */\n    /* flex-wrap: nowrap !important; */\n    /* justify-content: flex-start !important; */\n/* } */\n}\n\n@media screen and (max-width: 740px) {\n.chargingTitleBg_Orion {\n\tfont-size: 0.9em;\n}\n}\n\n\n@media screen and (max-width: 720px) {\n/* .chargingMainDiv_Bus{ */\n\t/* margin-top:124px; */\n/* } */\n}\n\n@media screen and (max-width: 480px) {\n/* .chargingMainDiv_Bus{ */\n\t/* margin-top:155px; */\n/* } */\n}\n\t\n@media screen and (max-width: 480px) {\n\n.chargingHeadfont_Orion {\n    font-size: 1rem;\n}\n.chargingTitleBg_Orion {\n\tfont-size: 0.9em;\n}\n}\n\n@media screen and (max-width: 320px) {\n\n}\n\n.highlight_five_Orion{\n  margin: auto;\n}\n\n.text_bottom_Orion{\n  margin-bottom: '-16px !important';\n  display: none;\n  z-index: 1;\n}\n.btn-infotable_Orion:active {\n  color: black;\n  background-color: #fff;\n  border-color: #32879c; \n}\n\n/* .col-19 {\n  flex: 0 0 calc(100% / 19);\n  max-width: calc(100% / 19);\n} */\n\n@media (min-width: 1440px) {\n  .col-19 {\n    flex: 0 0 calc(100% / 19);\n  max-width: calc(100% / 19);\n  }\n}\n\n@media (min-width: 1336px) {\n  .col-19 {\n    flex: 0 0 calc(100% / 19);\n  max-width: calc(100% / 19);\n  }\n}\n\n@media (min-width: 992px) {\n  .col-19 {\n    flex: 0 0 calc(100% / 19);\n  max-width: calc(100% / 19);\n  }\n}\n\n\n/* @media (max-width: 576px) {\n  .col-19 {\n      flex: 0 0 calc(100% / 19);\n      max-width: calc(100% / 19);\n    }\n}\n\n@media (min-width: 576px) and (max-width: 768px) {\n  .col-19 {\n      flex: 0 0 calc(100% / 19);\n      max-width: calc(100% / 19);\n    }\n}\n\n@media (min-width: 768px) and (max-width: 992px) {\n  .col-19 {\n      flex: 0 0 calc(100% / 19);\n      max-width: calc(100% / 19);\n    }\n}\n\n@media (min-width: 992px) {\n  .col-19 {\n      flex: 0 0 calc(100% / 19);\n      max-width: calc(100% / 19);\n    }\n} */\n\n.chargingChartboxNew_Orion {\n  background: #FFFFFF;\n  padding: 0px;\n  box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n  height: 293px;\n}\n\n.highBold {\n  font-weight: bold;\n  color: black;\n  font-size:16px !important\n}\n\n.filter_Orion_icon_f .rca_btn .rca_btn_Orion  {\n  background-color: #ffa650;\n}\n.filter_Orion_icon_f .rca_btn .rca_btn_Orion:hover{\n  background-color: #fcb877 !important; \n  border-color: #fcb877 !important;\n}\n\n.popUpTable{\n  background-color: rgb(131, 164, 207);\n  color: rgb(255, 255, 255);\n  position: sticky;\n  top: 0;\n  z-index: 0;\n}\n\n.custom-table .p-datatable-thead th {\n  background-color: #83A4CF;\n  /* Set your desired background color */\n  color: white;\n  /* Set your desired text color */\n}\n\n/* .custom-table .p-sortable-column .p-column-title .p-sortable-column-icon.pi-sort { */\n.custom-table .p-sortable-column .p-column-header-content .p-sortable-column-icon {\n  color: white;\n  height: 20px!important;\n  width: 12px!important;\n  /* Set your desired arrow color */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chargingMainDiv_Orion": `ChargingPageCustom_Orion_chargingMainDiv_Orion__AuQOs`,
	"btn-primary": `ChargingPageCustom_Orion_btn-primary__NEY1c`,
	"btn-outline-primary": `ChargingPageCustom_Orion_btn-outline-primary__Hmecn`,
	"ev_filter_icon": `ChargingPageCustom_Orion_ev_filter_icon__6T+oA`,
	"kpiSlowBTN_Orion": `ChargingPageCustom_Orion_kpiSlowBTN_Orion__HdIis`,
	"btn-check": `ChargingPageCustom_Orion_btn-check__QuZYs`,
	"btn": `ChargingPageCustom_Orion_btn__h0Tf7`,
	"active": `ChargingPageCustom_Orion_active__ajwDy`,
	"show": `ChargingPageCustom_Orion_show__76TNR`,
	"disabled": `ChargingPageCustom_Orion_disabled__1nYGt`,
	"dropdown-toggle": `ChargingPageCustom_Orion_dropdown-toggle__+Zx8-`,
	"ev_SButton": `ChargingPageCustom_Orion_ev_SButton__4MhP6`,
	"kpiFastBTN_Orion": `ChargingPageCustom_Orion_kpiFastBTN_Orion__rWc3t`,
	"btn-outline-warning": `ChargingPageCustom_Orion_btn-outline-warning__5h8u3`,
	"ev_FButton": `ChargingPageCustom_Orion_ev_FButton__REsL3`,
	"bg-white": `ChargingPageCustom_Orion_bg-white__RfA1q`,
	"chargingWidget_Orion": `ChargingPageCustom_Orion_chargingWidget_Orion__-0vym`,
	"chargingWidgetIcon_Orion": `ChargingPageCustom_Orion_chargingWidgetIcon_Orion__PA9sL`,
	"chargingWidgetIcon1_Orion": `ChargingPageCustom_Orion_chargingWidgetIcon1_Orion__tN1qo`,
	"chargingWidgetIcon_Orion-32_Orion": `ChargingPageCustom_Orion_chargingWidgetIcon_Orion-32_Orion__GUQ7Y`,
	"chargingTitleBg_Orion": `ChargingPageCustom_Orion_chargingTitleBg_Orion__OcRV9`,
	"chargingTitleChart_Orion": `ChargingPageCustom_Orion_chargingTitleChart_Orion__EAmOB`,
	"chargingChartbox_Orion": `ChargingPageCustom_Orion_chargingChartbox_Orion__cAp7d`,
	"wd_Orion": `ChargingPageCustom_Orion_wd_Orion__pGfow`,
	"wd_4_charts_Orion": `ChargingPageCustom_Orion_wd_4_charts_Orion__k5NDc`,
	"highlightBoxKpi_Orion": `ChargingPageCustom_Orion_highlightBoxKpi_Orion__tduGR`,
	"highlightTableSec_Orion": `ChargingPageCustom_Orion_highlightTableSec_Orion__zI5Dl`,
	"chargingChartHGT_Orion": `ChargingPageCustom_Orion_chargingChartHGT_Orion__SjogS`,
	"chargingH5_Bus": `ChargingPageCustom_Orion_chargingH5_Bus__pABM+`,
	"h5": `ChargingPageCustom_Orion_h5__0uCjV`,
	"chargingKpiSmallTxt_Orion": `ChargingPageCustom_Orion_chargingKpiSmallTxt_Orion__+UqR4`,
	"tableContent_Orion": `ChargingPageCustom_Orion_tableContent_Orion__tadFb`,
	"chargingFilterForm_Orion": `ChargingPageCustom_Orion_chargingFilterForm_Orion__hKYKN`,
	"form-label": `ChargingPageCustom_Orion_form-label__oTWVQ`,
	"chargingHeadfont_Orion": `ChargingPageCustom_Orion_chargingHeadfont_Orion__Gfyv4`,
	"topRightDropMenu_Orion": `ChargingPageCustom_Orion_topRightDropMenu_Orion__w3Hle`,
	"dropdown-menu": `ChargingPageCustom_Orion_dropdown-menu__SAfBZ`,
	"contentScroll_Orion": `ChargingPageCustom_Orion_contentScroll_Orion__aOfI1`,
	"toggleBtn_Orion": `ChargingPageCustom_Orion_toggleBtn_Orion__NyhuU`,
	"form-switch": `ChargingPageCustom_Orion_form-switch__DVjmK`,
	"form-check-input": `ChargingPageCustom_Orion_form-check-input__IOTj+`,
	"toggle-button-cover": `ChargingPageCustom_Orion_toggle-button-cover__fjYKl`,
	"dropdownSelectBtnCharging_Orion": `ChargingPageCustom_Orion_dropdownSelectBtnCharging_Orion__q1B-u`,
	"button-cover": `ChargingPageCustom_Orion_button-cover__tM2eX`,
	"knobs": `ChargingPageCustom_Orion_knobs__KpbVZ`,
	"layer": `ChargingPageCustom_Orion_layer__VBu+e`,
	"buttonbtn": `ChargingPageCustom_Orion_buttonbtn__7PVto`,
	"r": `ChargingPageCustom_Orion_r__WzkzU`,
	"button": `ChargingPageCustom_Orion_button__YeNzs`,
	"b2": `ChargingPageCustom_Orion_b2__iU8i-`,
	"checkbox": `ChargingPageCustom_Orion_checkbox__tbLv7`,
	"button-1_Orion": `ChargingPageCustom_Orion_button-1_Orion__fj84X`,
	"kpiNotificationSlow_Orion": `ChargingPageCustom_Orion_kpiNotificationSlow_Orion__VIBOR`,
	"kpiNotificationFast_Orion": `ChargingPageCustom_Orion_kpiNotificationFast_Orion__JCSF5`,
	"kpiNotificationBoth_Orion": `ChargingPageCustom_Orion_kpiNotificationBoth_Orion__PaF6n`,
	"col205": `ChargingPageCustom_Orion_col205__M79z8`,
	"highlight_five_Orion": `ChargingPageCustom_Orion_highlight_five_Orion__HM9ss`,
	"text_bottom_Orion": `ChargingPageCustom_Orion_text_bottom_Orion__-LR1Z`,
	"btn-infotable_Orion": `ChargingPageCustom_Orion_btn-infotable_Orion__IC3NF`,
	"col-19": `ChargingPageCustom_Orion_col-19__TJ3yP`,
	"chargingChartboxNew_Orion": `ChargingPageCustom_Orion_chargingChartboxNew_Orion__wo0aq`,
	"highBold": `ChargingPageCustom_Orion_highBold__Z-WGN`,
	"filter_Orion_icon_f": `ChargingPageCustom_Orion_filter_Orion_icon_f__zBCh0`,
	"rca_btn": `ChargingPageCustom_Orion_rca_btn__3sgvG`,
	"rca_btn_Orion": `ChargingPageCustom_Orion_rca_btn_Orion__Btw4S`,
	"popUpTable": `ChargingPageCustom_Orion_popUpTable__zG9t8`,
	"custom-table": `ChargingPageCustom_Orion_custom-table__JiZGa`,
	"p-datatable-thead": `ChargingPageCustom_Orion_p-datatable-thead__eQNsf`,
	"p-sortable-column": `ChargingPageCustom_Orion_p-sortable-column__3Y6QK`,
	"p-column-header-content": `ChargingPageCustom_Orion_p-column-header-content__sm5G3`,
	"p-sortable-column-icon": `ChargingPageCustom_Orion_p-sortable-column-icon__z5dMX`
};
export default ___CSS_LOADER_EXPORT___;
